import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MembershipModel } from '../../../../models/PatientAccount';
import { ActivatedRoute, Router } from '@angular/router';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { CountriesService } from '../../../../services/countries.service';
import { Specialty } from '../../../../models/Speciality';
import { SpecialityService } from 'src/app/services/speciality.service';
import { Consultation } from '../../../../models/consultdoctors';
import { DoctorsService } from '../../../../services/doctors.service';
import { SelectItem, ConfirmationService, MessageService } from "primeng/api";
import { fromEvent } from 'rxjs';
import { switchMap, takeUntil, pairwise } from 'rxjs/operators';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { Title } from '@angular/platform-browser';
import {
    Dimensions,
    ImageCroppedEvent,
    ImageTransform
} from "../../../../image-cropper/interfaces/index";
import { base64ToFile } from "../../../../image-cropper/utils/blob.utils";
import { DoctorprofileService } from '../../../../services/doctorprofile.service';
import { profileFetch, DoctorProfileUpdateData, DoctorProfileUpdateDataSubmit, boolean_DoctorProfileUpdateDataSubmit } from '../../../../models/Doctorprofile';
import { Country } from '../../../../models/Country';
import { States } from '../../../../models/States';
import { DaterenderService } from '../../../../services/daterender.service';
import { saveAs } from 'file-saver';
import { address, blockSpecialCharachters, city, DOCUMENT_SUPPORTED_TYPES, dose_input, GOOGLE_RECAPTCHA_SITE_KEY, IMAGE_PROFILE_ID_SUPPORTED_TYPES, name_input, number_input, phoneNumber, RESUME_SUPPORTED_TYPES, ROLES, SALUTATIONS, SIGNATURE_TYPES, textareaBox, zipCode } from "../../../../constant/constant";
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { DoctorRegistrationCheckerService } from 'src/app/services/doctor-registration-checker.service';
import { Board, Fellowship, Honours, LanguageSpoken, MedicalSchool, Privileges, Publication, Residency, Role, StatesToPractice } from 'src/app/models/doctorregistration';
import { TraceClassDecorator } from '@sentry/angular';
import { editMedProfLoginData } from 'src/app/models/medi-prof-login-edit-data';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@TraceClassDecorator()
@Component({
    selector: 'app-dprofileedit',
    templateUrl: './dprofileedit.component.html',
    styleUrls: ['../../../../../assets/css/custom-egd.css'],
    providers: [ConfirmationService],
})
export class DprofileeditComponent implements OnInit, AfterViewInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;

    @ViewChild("canvas") public canvas: ElementRef;
    showForm = true;

    tipsshowed: boolean = false;
    isPassword: boolean = true;
    confirm_password = "";

    avatar_url = "";
    resume_url = "";
    label = "";
    years: SelectItem[] = [];

    year = new Date().getFullYear();


    medicalSchool: MedicalSchool[] = [];

    Fellowship: Fellowship[] = [];

    StatesToPractice: StatesToPractice[] = [];

    Honours: Honours[] = [];

    Privileges: Privileges[] = [];

    Residency: Residency[] = [];

    Board: Board[] = [];

    Publication: Publication[] = [];


    firstName = "";
    middleName = "";
    lastName = "";
    dateBirth: Date = null;
    patient: MembershipModel;
    userid;
    selectedCountry: Country = null;
    countries: Country[] = [];
    selectedState: States = null;
    states: States[] = [];
    unformattedStates: any[];
    phone: any = []

    StatesToPractice_selectedState = null;
    selectedStateToPratice = null;
    primary_contact_number: string = "";
    secondary_contact_number: string = "";
    selectedPhoneCode_primary: string = "";
    selectedPhoneCode_secondary: string = "";
    temp;
    agree: boolean = false;
    patient_guid: any;

    // statesInput:boolean=true;
    // statesInputDisabled:boolean=true;
    specialities: Specialty[];
    sec_specialities: SelectItem[] = [];
    seletedPrimarySpeciality;
    selectedFeatured;
    consultation: Consultation;
    display: boolean = false;
    doctorreg: DoctorProfileUpdateDataSubmit;
    name = "";
    year_of_graduation = null;
    License_no = "";
    national_license_no: string = "";
    honour_name = "";
    privileges_name = "";
    board_certification_name = "";
    publication_name = "";
    national_license: boolean = false;
    roles: Role[];
    selected_role: Role;
    selectedSecondarySpeciality: string[] = [];
    is_revalidation_cme_false = true;
    selectedRevalidation_cme = null;
    dateTime = new Date();
    profilePhoto: File = null;
    resume: File = null;
    profile_result: boolean = null;
    resume_result: boolean = null;
    sig_result: boolean = null;
    medicalSchool_edit_id = -1;
    StatesToPractice_edit_id = -1;
    fellowship_edit_id = -1;
    residency_edit_id = -1;
    Honours_edit_id = -1;
    Privileges_edit_id = -1;
    Boards_edit_id = -1;
    Publication_edit_id = -1;
    temp_medicalSchool_name = "";
    temp_medicalSchool_year = null;
    temp_StatesToPractice_selectedStateToPratice: { state_name: string, state_id: number } = { state_name: "", state_id: -1 };
    temp_StatesToPractice_License_no = "";
    // temp_StatesToPractice_state_id=null;
    // temp_StatesToPractice_stateOption=null;
    temp_fellowship_name = "";
    temp_fellowship_year = null;
    temp_residency_name = "";
    temp_residency_year = null;
    temp_Honours_name = "";
    edited_honour_name = "";
    temp_privileges_name = "";
    edited_privileges_name = "";
    temp_boards_name = "";
    edited_boards_name = "";
    temp_publication_name = "";
    edited_publication_name = "";
    confirmDialogVisible1: boolean = false;
    confirmDialogVisible2: boolean = false;
    confirmDialogVisible3: boolean = false;
    confirmDialogVisible4: boolean = false;
    confirmDialogVisible5: boolean = false;
    confirmDialogVisible6: boolean = false;
    confirmDialogVisible7: boolean = false;
    confirmDialogVisible8: boolean = false;

    signatureDialog: boolean = false;

    signatureFile = null;
    provider_id: string = "";
    imageChangedEvent: any = "";
    croppedImage: any = "";
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};
    timezone: { label: string, value: number }[] = [];
    selectedTimezone = null;
    current_doctor_userid = "";
    doctor_userid = "";
    signatureOptionSelected = null;

    languages: LanguageSpoken[] = [];
    selected_language = null;


    doctor: DoctorProfileUpdateData = null;
    changePassword: boolean = false;
    changePin: boolean = false;
    changePhoto: boolean = false;
    changeResume: boolean = false;
    changeSignature: boolean = false;
    password = "";
    confirmPassword = '';
    prevpassword = "";
    updateDataResult: boolean = null;
    signature_file_name = "";

    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    loading: boolean;

    addedSpeciality: string = "";

    currentRoleID: number = 0;
    editOthers: boolean = false;

    signature_file_type_error: boolean = false;

    salutation: SelectItem[] = [];
    selected_salutation: SelectItem = null;
    pinMasking: boolean = true;
    noteDialog: boolean = true;
    recaptcha_Reset: boolean = false;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    error_message_result: PromiseResult;
    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    doctorreg_boolean: boolean_DoctorProfileUpdateDataSubmit = this.doctorRegistrationCheckerService.boolean_DoctorProfileUpdateDataSubmit_init();
    editLoginData: editMedProfLoginData = new editMedProfLoginData();
    available_roles = ROLES;
    slug: string = "";
    constructor(
        private doctorsservice: DoctorsService,
        private router: Router,
        private route: ActivatedRoute,
        private breadcrumbService: DoctorBreadcrumbService,
        private countryService: CountriesService,
        private specialtyservice: SpecialityService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private readonly doctorprofileService: DoctorprofileService,
        private readonly daterenderService: DaterenderService,
        private readonly utilitiesService: UtilitiesService,
        private doctorRegistrationCheckerService: DoctorRegistrationCheckerService,
        private titleService: Title,
        private readonly providerStateService: ProviderStateService
    ) {
        this.roles = [
            { role_id: 1, name: 'Doctor' },
            { role_id: 2, name: 'Admin' },
            { role_id: 3, name: 'Super Admin' },
            { role_id: 4, name: 'Super Admin Doctor' },
            { role_id: 5, name: 'Admin Doctor' },


        ];
        this.timezone = [
            { label: "IST", value: -330 },
            { label: "PST", value: 480 },
            { label: "EST", value: 600 },
            { label: "GMT", value: 0 },
        ];
        this.posting = false;
        this.loading = true;
    }


    private async GetProfileData(): Promise<void> {
        this.loading = true;
        let data: profileFetch = {
            user_guid: this.doctor_userid,
            current_user_guid: this.current_doctor_userid,
        }

        await this.doctorprofileService.getDoctorsProfileDataForDoctorDash(data)
            .toPromise()
            .then(async result => {
                this.response = result;
                if (this.response.success) {

                    this.doctor = result.data;
                    this.editLoginData.has_verified_email = result.data.data.has_verified_email;
                    this.editLoginData.has_verified_phone = result.data.data.has_verified_phone;
                    this.editLoginData.e_email = result.data.data.d_email || "";
                    this.editLoginData.primary_contact_number = result.data.data.primary_contact_number || "";
                    this.editLoginData.country_phone_code = result.data.data.country.phone_code;
                    this.editLoginData.country_id = result.data.data.country.id;


                }
                else if (!this.response.success) {
                    this.error = result.error;
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        sticky: true,
                        detail: result.error.code + " : " + result.error.message,
                    });
                }
                // this.loading = false;
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
        if (this.doctor.data.country.id != null) {

            for (const country of this.countries) {
                if (country.id == this.doctor.data.country.id) {
                    this.selectedCountry = country;
                    break;
                }
            }
        }



        await this.changeStates();

        this.doctorreg.gender = this.doctor.data.gender;
        this.doctorreg.first_name = this.doctor.data.first_name;
        this.doctorreg.middle_name = this.doctor.data.middle_name;
        this.doctorreg.last_name = this.doctor.data.last_name;

        this.doctorreg.date_of_birth_date = new Date(this.doctor.data.date_of_birth.replace(/-/g, '/'));


        if (this.doctor.data?.avatar_url == null) {
            this.avatar_url = "";
        }
        else {
            this.avatar_url = this.doctor.data.avatar_url;
        }

        this.label = this.doctorreg.first_name + " " + (this.doctorreg.middle_name ? this.doctorreg.middle_name : '') + " " + this.doctorreg.last_name;

        this.doctorreg.city = this.doctor.data.city || "";
        this.doctorreg.zip_code = this.doctor.data.zip_code || "";
        this.doctorreg.address_line_1 = this.doctor.data.address_line_1 || "";
        this.doctorreg.address_line_2 = this.doctor.data.address_line_2 || "";

        if (this.doctor.data.state_name != null) {
            for (const state of this.states) {
                if (state.state_name == this.doctor.data.state_name.toString()) {
                    this.selectedState = state;
                    break;
                }
            }
        }


        if (this.doctor.data.doctor_profile != null) {
            for (const primary_spec of this.specialities) {
                if (primary_spec.specialty_name == this.doctor.data.doctor_profile.speciality.specialty_name.toString()) {
                    this.seletedPrimarySpeciality = primary_spec;
                    break;
                }
            }


            for (const salute of this.salutation) {
                if (salute.value.toString() == this.utilitiesService.titlecase(this.doctor.data.doctor_profile.salutation).toString()) {
                    this.selected_salutation = salute;
                    break;
                }
            }


            let tempSpaecialitiesName: string[] = []
            for (let i = 0; i < this.specialities.length; i++) {
                tempSpaecialitiesName.push(this.specialities[i].specialty_name);
            }
            for (let i = 0; i < this.doctor?.data?.doctor_profile?.secondary_speciality?.length; i++) {
                tempSpaecialitiesName.push(this.doctor?.data?.doctor_profile?.secondary_speciality[i]);
            }

            let tempSpaecialities = Array.from(new Set(tempSpaecialitiesName)).sort()
            let temp: SelectItem[] = [];
            for (let i = 0; i < tempSpaecialities.length; i++) {
                temp.push({ label: tempSpaecialities[i], value: tempSpaecialities[i] });
            }
            this.sec_specialities = temp;
            this.selectedSecondarySpeciality = this.doctor?.data?.doctor_profile?.secondary_speciality || [];

            //     let secondary_speciality_data:any[]=this.doctor.data.doctor_profile.secondary_speciality    
            //     let secondary_speciality_temp=[];
            //     let i=0;            
            // for(const  secondary_spec of secondary_speciality_data){
            //     for(let i=0;i<this.specialities.length;i++){
            //         if(this.specialities[i].id.toString()==secondary_spec.toString()){
            //             secondary_speciality_temp.push(this.specialities[i]);
            //             // break;
            //         }
            //     }
            // }

            // this.selectedSecondarySpeciality=secondary_speciality_temp;


            let language_data: any[] = this.doctor.data.doctor_profile.language_id
            let language_temp = [];
            let j = 0;
            for (const language of language_data) {
                for (let j = 0; j < this.languages.length; j++) {
                    if (this.languages[j].id.toString() == language.toString()) {
                        language_temp.push(this.languages[j]);
                        // break;
                    }
                }
            }

            this.selected_language = language_temp;
            if (this.doctor.data.doctor_profile.revalidation_cme != null) {
                this.is_revalidation_cme_false = false;
                this.doctorreg.revalidation_cme = Number(this.doctor.data.doctor_profile.revalidation_cme)
                this.selectedRevalidation_cme = { label: this.doctor.data.doctor_profile.revalidation_cme.toString(), value: this.doctor.data.doctor_profile.revalidation_cme.toString() };
            }
            else if (this.doctor.data.doctor_profile.revalidation_cme == null) {
                this.is_revalidation_cme_false = true;
                this.doctorreg.revalidation_cme = null;
                this.selectedRevalidation_cme = null;
            }

            // this.doctorreg.gender = this.doctor.data.gender;
            // this.doctorreg.first_name = this.doctor.data.first_name;
            // this.doctorreg.middle_name = this.doctor.data.middle_name;
            // this.doctorreg.last_name = this.doctor.data.last_name;
            this.doctorreg.degree = this.doctor.data.doctor_profile.degree;
            // this.doctorreg.date_of_birth_date = new Date(this.doctor.data.date_of_birth.replace(/-/g, '/'));
            // this.selectedState=this.doctor.data.state_name;
            // rest
            // this.medicalSchool=this.doctor.data.doctor_profile.education.medical_school;
            // this.doctorreg.years_experience=this.doctor.data.doctor_profile.years_experience;
            //this.doctoreditp.gender = result.data.data.gender;
            let temp_MedicalSchool: any[] = []
            for (let i = 0; i < this.doctor.data.doctor_profile.education?.medical_school?.length; i++) {
                temp_MedicalSchool.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.education.medical_school[i].name.toString(),
                        year: this.doctor.data.doctor_profile.education.medical_school[i].year.toString(),
                    }
                )
            }
            this.medicalSchool = temp_MedicalSchool;

            let temp_Board: Board[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.board_certification?.length; i++) {
                temp_Board.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.board_certification[i]
                    }
                )
            }
            this.Board = temp_Board;

            let temp_Publication: Publication[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.publications?.length; i++) {
                temp_Publication.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.publications[i]
                    }
                )
            }
            this.Publication = temp_Publication;

            let temp_Honours: Honours[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.honors_awards_recognition?.length; i++) {
                temp_Honours.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.honors_awards_recognition[i]
                    }
                )
            }
            this.Honours = temp_Honours;

            let temp_Privileges: Privileges[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.hospital_privileges?.length; i++) {
                temp_Privileges.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.hospital_privileges[i]
                    }
                )
            }
            this.Privileges = temp_Privileges;

            let temp_Fellowship: Fellowship[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.education?.fellowship?.length; i++) {
                temp_Fellowship.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.education.fellowship[i].name.toString(),
                        year: this.doctor.data.doctor_profile.education.fellowship[i].year.toString(),
                    }
                )
            }
            this.Fellowship = temp_Fellowship;

            let temp_Residency: Residency[] = [];
            for (let i = 0; i < this.doctor.data.doctor_profile.education?.residency?.length; i++) {
                temp_Residency.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctor.data.doctor_profile.education.residency[i].name.toString(),
                        year: this.doctor.data.doctor_profile.education.residency[i].year.toString(),
                    }
                )
            }
            this.Residency = temp_Residency;

            // if (this.doctor.data?.avatar_url == null) {
            //     this.avatar_url = "";
            // }
            // else {
            //     this.avatar_url = this.doctor.data.avatar_url;
            // }

            // this.label = this.doctorreg.first_name + " " + this.doctorreg.middle_name + " " + this.doctorreg.last_name;



            this.doctorreg.npi_number = this.doctor.data.doctor_profile.npi_number || "";
            this.doctorreg.pin = this.doctor.data.doctor_profile.pin;
            if (this.doctor.data.doctor_profile?.resume_url != null)
                this.resume_url = this.doctor.data.doctor_profile?.resume_url;
            // this.doctorreg.city = this.doctor.data.city;
            // this.doctorreg.zip_code = this.doctor.data.zip_code;
            // this.doctorreg.address_line_1 = this.doctor.data.address_line_1;
            // this.doctorreg.address_line_2 = this.doctor.data.address_line_2;
            this.doctorreg.years_experience = Number(this.doctor.data.doctor_profile.years_experience) || 0;

            if (this.doctor.data.doctor_profile.secondary_contact_number != null) {
                this.secondary_contact_number = this.doctor.data.doctor_profile.secondary_contact_number.slice(-10)
            };
            this.primary_contact_number = this.doctor.data.doctor_profile.primary_contact_number.slice(-10);
            this.doctorreg.description = this.doctor.data.doctor_profile.description || "";
            // this.Fellowship=this.doctor.data.doctor_profile.education.fellowship;
            // this.Residency=this.doctor.data.doctor_profile.education.residency;
            this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
            this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;
            this.national_license = this.selectedCountry.is_national_license;
            if (this.national_license) {
                this.national_license_no = this.doctor.data.doctor_profile.states_to_practice[0].license_no;
            }
            else if (!this.national_license) {
                let temp_StatesToPractice: StatesToPractice[] = []
                for (let i = 0; i < this.doctor.data.doctor_profile.states_to_practice.length; i++) {
                    temp_StatesToPractice.push(
                        {
                            si_no: (i + 1).toString(),
                            state_name: this.doctor.data.doctor_profile.states_to_practice[i].state_name,
                            state_id: this.doctor.data.doctor_profile.states_to_practice[i].state_id,
                            license_no: this.doctor.data.doctor_profile.states_to_practice[i].license_no,
                            state_data: JSON.stringify({
                                state_name: this.doctor.data.doctor_profile.states_to_practice[i].state_name,
                                state_id: this.doctor.data.doctor_profile.states_to_practice[i].state_id,
                            })
                        }
                    )
                }
                this.StatesToPractice = temp_StatesToPractice;
            }
        }



        this.currentRoleID = this.doctor.data.role_id
        if (this.currentRoleID == 1 || this.currentRoleID == 4 || this.currentRoleID == 5) {
            this.roles = [
                { role_id: 1, name: 'Doctor' },
                // { role_id: 2, name: 'Admin' },
                // { role_id: 3, name: 'Super Admin' },
                { role_id: 4, name: 'Super Admin Doctor' },
                { role_id: 5, name: 'Admin Doctor' },
            ];
        }
        else if (this.currentRoleID == 2 || this.currentRoleID == 3) {
            this.roles = [
                // { role_id: 1, name: 'Doctor' },
                { role_id: 2, name: 'Admin' },
                { role_id: 3, name: 'Super Admin' },
                // { role_id: 4, name: 'Super Admin Doctor' },
                // { role_id: 5, name: 'Admin Doctor' },
            ];
        }

        this.loading = false;

    }

    @Input() public width = 300;
    @Input() public height = 70;

    private cx: CanvasRenderingContext2D;

    public ngAfterViewInit() {
        // const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        // this.cx = canvasEl.getContext("2d");

        // canvasEl.width = this.width;
        // canvasEl.height = this.height;

        // this.cx.lineWidth = 3;
        // this.cx.lineCap = "round";
        // this.cx.strokeStyle = "#000";

        // this.captureEvents(canvasEl);
        // canvasEl.toBlob((res) => {

        // })
    }

    private async captureEvents(canvasEl: HTMLCanvasElement) {
        // this will capture all mousedown events from the canvas element
        await fromEvent(canvasEl, "mousedown")
            .pipe(
                switchMap((e) => {
                    // after a mouse down, we'll record all mouse moves
                    return fromEvent(canvasEl, "mousemove").pipe(
                        // we'll stop (and unsubscribe) once the user releases the mouse
                        // this will trigger a 'mouseup' event
                        takeUntil(fromEvent(canvasEl, "mouseup")),
                        // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
                        takeUntil(fromEvent(canvasEl, "mouseleave")),
                        // pairwise lets us get the previous value to draw a line from
                        // the previous point to the current point
                        pairwise()
                    );
                })
            )
            .subscribe(async (res: [MouseEvent, MouseEvent]) => {
                const rect = canvasEl.getBoundingClientRect();

                // previous and current position with the offset
                const prevPos = {
                    x: res[0].clientX - rect.left,
                    y: res[0].clientY - rect.top,
                };

                const currentPos = {
                    x: res[1].clientX - rect.left,
                    y: res[1].clientY - rect.top,
                };

                // this method we'll implement soon to do the actual drawing
                await this.drawOnCanvas(prevPos, currentPos);

            });
    }

    private drawOnCanvas(
        prevPos: { x: number; y: number },
        currentPos: { x: number; y: number }
    ) {
        if (!this.cx) {
            return;
        }

        this.cx.beginPath();

        if (prevPos) {
            this.cx.moveTo(prevPos.x, prevPos.y); // from
            this.cx.lineTo(currentPos.x, currentPos.y);
            this.cx.stroke();
        }
    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.error_message_result = {
            success: null,
            error: null,
            data: null
        };
    }


    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Doctor Profile Edit");
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },

            { label: 'Edit Profile' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        this.response = {
            success: null,
            error: null,
            data: null
        }
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.showForm = true;
        let temp_patient_guid: string;
        this.route.params.subscribe(async (params) => {
            temp_patient_guid = params.user_guid;


            if (temp_patient_guid != null) {
                this.doctor_userid = temp_patient_guid
                this.current_doctor_userid = sessionStorage.getItem('userid');
                this.editOthers = true;
            }
            else {
                this.doctor_userid = sessionStorage.getItem('userid');
                this.current_doctor_userid = sessionStorage.getItem('userid');
                this.editOthers = false;

            }

        });

        // this.currentRoleID=Number(sessionStorage.getItem("medical_profession_role"))
        // if(this.currentRoleID==1 || this.currentRoleID==4 || this.currentRoleID==5){
        //     this.roles = [
        //         { role_id: 1, name: 'Doctor' },
        //         // { role_id: 2, name: 'Admin' },
        //         // { role_id: 3, name: 'Super Admin' },
        //         { role_id: 4, name: 'Super Admin Doctor' },
        //         { role_id: 5, name: 'Admin Doctor' },
        //     ];
        // }
        // else if(this.currentRoleID==2 || this.currentRoleID==3 ){
        //     this.roles = [
        //         // { role_id: 1, name: 'Doctor' },
        //         { role_id: 2, name: 'Admin' },
        //         { role_id: 3, name: 'Super Admin' },
        //         // { role_id: 4, name: 'Super Admin Doctor' },
        //         // { role_id: 5, name: 'Admin Doctor' },
        //     ];
        // }
        for (let i = 1900; i <= this.year; i++) {
            this.years.push({ label: (i).toString(), value: (i).toString() });
        }
        this.years.reverse();
        // this.years.push({label:"Select",value:null})

        this.dateTime.setDate(this.dateTime.getDate());
        this.dateTime.setFullYear(this.dateTime.getFullYear() - 18);
        // sessionStorage.setItem('userid','1872468e-9528-42b1-a172-014c3445154c');



        let temp_salutations: SelectItem[] = [];
        for (let i = 0; i < SALUTATIONS.length; i++) {
            temp_salutations.push({ label: SALUTATIONS[i].toString(), value: SALUTATIONS[i].toString() });
        }
        this.salutation = temp_salutations;

        this.doctorreg = {
            current_user_guid: this.current_doctor_userid,
            first_name: "",
            middle_name: "",
            last_name: "",
            salutation: null,
            gender: "",//temp hack
            is_password: false,
            d_password: "",
            prev_password: "",
            date_of_birth: null,
            date_of_birth_date: null,
            country_id: null,
            state_name: "",
            degree: "",
            city: "",
            address_line_1: "",
            address_line_2: "",
            zip_code: "",
            primary_speciality_id: null,
            secondary_speciality: [],
            years_experience: null,
            license_number: "",
            education: {},
            npi_number: "",
            revalidation_cme: null,
            states_to_practice: [],
            board_certification: [],
            honors_awards_recognition: [],
            publications: [],
            hospital_privileges: [],
            description: "",
            primary_contact_number: "",
            secondary_contact_number: "",
            is_pin: false,
            pin: "",
            language_id: [],
            timezone: 0,
            recaptcha: "",

        }
        this.doctorreg_boolean = await this.doctorRegistrationCheckerService.boolean_DoctorProfileUpdateDataSubmit_init();
        this.editLoginData = new editMedProfLoginData();
        await this.recaptchaReset();
        await this.getCountries();
        await this.getSpecialty();
        await this.getLanguages();

        this.medicalSchool = [
            // { si_no:'1', name: 'Osmania', year: '1992'},
        ];
        this.Fellowship = [
            // { si_no:'1', name: 'Osmania', year: '1996'},
        ];
        this.StatesToPractice = [
            // { si_no:'1', name: 'California', License: '923456'},
        ];
        this.Honours = [
            // { si_no:'1', name: 'King George, CA'},
        ];
        this.Residency = [
            // { si_no:'1', name: 'Osmania', year: '1992'},
        ];
        this.Privileges = [
            // { si_no:'1', name: 'Osmania'},
        ];
        this.Board = [
            // { si_no:'1', name: 'Internal Medicine Health'},
        ];
        this.Publication = [
            // { si_no:'1', name: 'Internal Medicine Health'},
        ];
        this.noteDialog = true;

        await this.GetProfileData();
    }

    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }

    displayMedicalSchool: boolean = false;
    displayFellowship: boolean = false;
    displayStates: boolean = false;
    displayHonours: boolean = false;
    displayResidency: boolean = false;
    displayBcertification: boolean = false;
    displayPublications: boolean = false;
    displayPrivileges: boolean = false;
    editdisplayMedicalSchool: boolean = false;
    editdisplayFellowship: boolean = false;
    editdisplayResidency: boolean = false;
    editdisplayStatesToPractice: boolean = false;

    showAddMedicalSchoolDialog() {
        this.displayMedicalSchool = true;
    }
    showAddFellowshipDialog() {
        this.displayFellowship = true;
    }
    showAddStatesDialog() {
        this.displayStates = true;
    }
    showAddHonoursDialog() {
        this.displayHonours = true;
    }
    showAddResidencyDialog() {
        this.displayResidency = true;
    }
    showAddBcertificationDialog() {
        this.displayBcertification = true;
    }
    showAddPublicationsDialog() {
        this.displayPublications = true;
    }
    showAddPrivilegesDialog() {
        this.displayPrivileges = true;
    }

    close() {
        this.displayMedicalSchool = false;
        this.displayFellowship = false;
        this.displayStates = false;
        this.displayHonours = false;
        this.displayResidency = false;
        this.displayBcertification = false;
        this.displayPublications = false;
        this.displayPrivileges = false;
        this.signatureDialog = false;
        this.resetDialog();

    }

    resetDialog() {
        this.name = "";
        this.year_of_graduation = null;
        this.selectedStateToPratice = null;
        this.License_no = "";
        this.honour_name = "";
        this.privileges_name = "";
        this.year_of_graduation = null;
        this.board_certification_name = "";
        this.publication_name = "";

        this.temp_medicalSchool_name = "";
        this.temp_medicalSchool_year = null;

        this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
        this.temp_StatesToPractice_License_no = "";

        this.temp_fellowship_name = "";
        this.temp_fellowship_year = null;

        this.temp_residency_name = "";
        this.temp_residency_year = null;

        this.edited_honour_name = "";
        this.temp_Honours_name = "";

        this.edited_privileges_name = "";
        this.temp_privileges_name = "";

        this.edited_boards_name = "";
        this.temp_boards_name = "";

        this.edited_publication_name = "";
        this.temp_publication_name = "";

    }

    async getLanguages() {
        await this.doctorsservice.GetLanguageSpoken().toPromise().then(result => {
            if (result.success) {
                let temp_languages: LanguageSpoken[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let temp: LanguageSpoken = {
                        id: result.data[i].id,
                        language_name: result.data[i].language_name,
                        english_name: result.data[i].english_name,
                        label: result.data[i].english_name + " (" + result.data[i].language_name + ")",
                    }
                    temp_languages.push(temp)
                }
                this.languages = temp_languages;
            }
        });




    }

    async getCountries() {
        try {

            await this.countryService
                .getCountries(this.provider_id)
                .toPromise()
                .then(countries => {
                    this.countries = countries;
                    countries.forEach((ele) => {
                        ele["final_phone_code"] = '+' + String(ele.phone_code);
                        ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
                        this.editLoginData.country_codes.push({
                            id: Number(ele.id),
                            value: {
                                label: ele["final_label_string"],
                                value: ele["final_phone_code"],
                            }
                        });
                    });
                }).catch((err) => {
                    console.error(err);
                });

        } catch (error) {

        }


    }
    async getStates(country_id) {
        await this.countryService.getStates(country_id).toPromise().then(states => this.unformattedStates = states);

    }
    async getSpecialty() {

        await this.specialtyservice.GetAllSpecialities(undefined, this.provider_id).toPromise().then(result => {

            this.specialities = result.data;
        })
        let temp: SelectItem[] = [];
        for (let i = 0; i < this.specialities.length; i++) {
            temp.push({ label: this.specialities[i].specialty_name, value: this.specialities[i].specialty_name });
        }
        this.sec_specialities = temp;


    }
    async onSpecialityChange() {
        if (this.seletedPrimarySpeciality.id != 0) {
            // this.sec_specialities=this.specialities;
            this.doctorreg.primary_speciality_id = this.seletedPrimarySpeciality.id;

            // let temp :AllSpeciality[]= [];
            // this.selectedSecondarySpeciality=[]
            // // let j;
            // for (let i = 0; i < this.sec_specialities.length; i++) {
            //     if (
            //         this.sec_specialities[i].id != this.seletedPrimarySpeciality.id &&
            //         this.sec_specialities[i].specialty_name != this.seletedPrimarySpeciality.specialty_name
            //     ) {
            //         temp.push(this.sec_specialities[i]);
            //     } else {
            //         continue;
            //     }
            // }

            // this.sec_specialities = temp;

        }
    }

    onRevalidationChange(event: Event) {

        this.is_revalidation_cme_false = Boolean(event);
        if (this.is_revalidation_cme_false) {
            this.selectedRevalidation_cme = null;
        }
        // let is_dropdown:boolean=Event

        // if(is_dropdown) {
        //   this.doctorreg.revalidation_cme=this.selectedRevalidation_cme.value;

        // }
        //  else if(!is_dropdown) {
        //   this.is_revalidation_cme_false=Boolean(Event);
        //   this.doctorreg.revalidation_cme=null;
        //   this.selectedRevalidation_cme=null;
        //  }

    }

    onAgreeChange(Event: Event) {

        this.agree = Boolean(Event);
    }

    async changeStates() {

        this.unformattedStates = [];
        this.states = [];
        this.temp = []
        this.phone = [];
        this.selectedState = null;
        this.selectedStateToPratice = null;
        this.national_license = this.selectedCountry.is_national_license;
        this.national_license_no = "";
        this.StatesToPractice = [];
        // this.getStates(this.selectedCountry.id);
        await this.countryService.getStates(Number(this.selectedCountry.id)).toPromise().then(states => this.unformattedStates = states);


        if (this.unformattedStates.length > 0) {
            // this.statesInput=false;

            for (let i = 0; i < this.unformattedStates.length; i++) {
                this.temp.push({ state_name: this.unformattedStates[i].state_name, state_id: this.unformattedStates[i].id });
            }
            this.states = this.temp;


        }
        else {
            // this.statesInput=true;
            // this.statesInputDisabled=false;
        }

        this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
        this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;



    }

    changePinType() {
        this.pinMasking = !this.pinMasking;
    }

    // uploadFiles(file:File[]){

    //   //this.doctorreg.file=file[0];

    // }

    showDialog() {
        this.display = true;
    }
    addMedicalSchool() {
        this.medicalSchool.push({ si_no: (this.medicalSchool.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteMedicalSchool(row) {
        let temp: MedicalSchool[] = [];
        let j;
        for (let i = 0; i < this.medicalSchool.length; i++) {
            if (this.medicalSchool[i].name != row.name && this.medicalSchool[i].year != row.year) {
                temp.push(this.medicalSchool[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.medicalSchool.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.medicalSchool[i].name, year: this.medicalSchool[i].year })
        }
        this.medicalSchool = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addFellowship() {
        this.Fellowship.push({ si_no: (this.Fellowship.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteFellowship(row) {
        let temp: Fellowship[] = [];
        let j;
        for (let i = 0; i < this.Fellowship.length; i++) {
            if (this.Fellowship[i].name != row.name && this.Fellowship[i].year != row.year) {
                temp.push(this.Fellowship[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Fellowship.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Fellowship[i].name, year: this.Fellowship[i].year })
        }
        this.Fellowship = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addStatestoPratice() {
        this.StatesToPractice.push({ si_no: (this.StatesToPractice.length + 1).toString(), state_name: this.selectedStateToPratice.state_name, state_id: this.selectedStateToPratice.state_id, license_no: this.License_no, state_data: JSON.stringify({ state_name: this.selectedStateToPratice.state_name, state_id: this.selectedStateToPratice.state_id }) })
        this.selectedStateToPratice = null;
        this.License_no = "";
    }
    deleteStatestoPratice(row) {
        let temp: StatesToPractice[] = [];
        let j;
        for (let i = 0; i < this.StatesToPractice.length; i++) {
            if (this.StatesToPractice[i].state_name != row.state_name && this.StatesToPractice[i].state_id != row.state_id && this.StatesToPractice[i].license_no != row.license_no) {
                temp.push(this.StatesToPractice[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.StatesToPractice.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), state_name: this.StatesToPractice[i].state_name, state_id: this.StatesToPractice[i].state_id, license_no: this.StatesToPractice[i].license_no, state_data: JSON.stringify({ state_name: this.StatesToPractice[i].state_name, state_id: this.StatesToPractice[i].state_id }) })
        }
        this.StatesToPractice = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }
    addHonours() {
        this.Honours.push({ si_no: (this.Honours.length + 1).toString(), name: this.honour_name })
        this.honour_name = "";
    }
    deleteHonours(row) {
        let temp: Honours[] = [];
        let j;
        for (let i = 0; i < this.Honours.length; i++) {
            if (this.Honours[i].name != row.name) {
                temp.push(this.Honours[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Honours.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Honours[i].name })
        }
        this.Honours = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addPrivileges() {
        this.Privileges.push({ si_no: (this.Privileges.length + 1).toString(), name: this.privileges_name })
        this.privileges_name = "";
    }
    deletePrivileges(row) {
        let temp: Privileges[] = [];
        let j;
        for (let i = 0; i < this.Privileges.length; i++) {
            if (this.Privileges[i].name != row.name) {
                temp.push(this.Privileges[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Privileges.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Privileges[i].name })
        }
        this.Privileges = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });

    }

    addResidency() {
        this.Residency.push({ si_no: (this.Residency.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteResidency(row) {
        let temp: Residency[] = [];
        let j;
        for (let i = 0; i < this.Residency.length; i++) {
            if (this.Residency[i].name != row.name && this.Residency[i].year != row.year) {
                temp.push(this.Residency[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Residency.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Residency[i].name, year: this.Residency[i].year })
        }
        this.Residency = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addBoard() {
        this.Board.push({ si_no: (this.Board.length + 1).toString(), name: this.board_certification_name })
        this.board_certification_name = "";
    }
    deleteBoard(row) {
        let temp: Board[] = [];
        let j;
        for (let i = 0; i < this.Board.length; i++) {
            if (this.Board[i].name != row.name) {
                temp.push(this.Board[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Board.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Board[i].name })
        }
        this.Board = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addPublication() {
        this.Publication.push({ si_no: (this.Publication.length + 1).toString(), name: this.publication_name })
        this.publication_name = "";
    }
    deletePublication(row) {
        let temp: Publication[] = [];
        let j;
        for (let i = 0; i < this.Publication.length; i++) {
            if (this.Publication[i].name != row.name) {
                temp.push(this.Publication[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Publication.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Publication[i].name })
        }
        this.Publication = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    uploadProfileFiles(file: File[]) {

        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.profilePhoto = null;
            }
            else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.profilePhoto = file[0];
            }
        }
        else {
            this.profilePhoto = null;
        }


    }

    onRemovePhoto() {

        this.profilePhoto = null;
    }

    uploadResumeFiles(file: File[]) {

        if (this.resume_types.includes(file[0].type.toLowerCase())) {
            // this.resume = file[0];
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.resume = null;
            }
            else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.resume = file[0];
            }
        }
        else {
            this.resume = null;
        }


    }

    onRemoveResume() {

        this.resume = null;
    }

    canceleditData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool_edit_id = -1;
            this.medicalSchool[id - 1].name = this.temp_medicalSchool_name;
            this.medicalSchool[id - 1].year = this.temp_medicalSchool_year;
            this.editdisplayMedicalSchool = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_medicalSchool_name = "";
            this.temp_medicalSchool_year = null;
        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice_edit_id = -1;
            this.StatesToPractice[id - 1].state_name = this.temp_StatesToPractice_selectedStateToPratice.state_name;
            this.StatesToPractice[id - 1].license_no = this.temp_StatesToPractice_License_no;
            this.StatesToPractice[id - 1].state_id = this.temp_StatesToPractice_selectedStateToPratice.state_id;

            this.editdisplayStatesToPractice = false;
            this.selectedStateToPratice = null;
            this.License_no = "";
            this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
            this.temp_StatesToPractice_License_no = "";

        }
        else if (form == "Fellowship") {
            this.fellowship_edit_id = -1;
            this.Fellowship[id - 1].name = this.temp_fellowship_name;
            this.Fellowship[id - 1].year = this.temp_fellowship_year;
            this.editdisplayFellowship = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_fellowship_name = "";
            this.temp_fellowship_year = null;
        }
        else if (form == "Residency") {
            this.residency_edit_id = -1;
            this.Residency[id - 1].name = this.temp_residency_name;
            this.Residency[id - 1].year = this.temp_residency_year;
            this.editdisplayResidency = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_residency_name = "";
            this.temp_residency_year = null;
        }
        else if (form == "Honours") {
            this.Honours_edit_id = -1;
            this.Honours[id - 1].name = this.temp_Honours_name;
            this.edited_honour_name = "";
            this.temp_Honours_name = "";
        }
        else if (form == "Privileges") {
            this.Privileges_edit_id = -1;
            this.Privileges[id - 1].name = this.temp_privileges_name;
            this.edited_privileges_name = "";
            this.temp_privileges_name = "";
        }
        else if (form == "Boards") {
            this.Boards_edit_id = -1;
            this.Board[id - 1].name = this.temp_boards_name;
            this.edited_boards_name = "";
            this.temp_boards_name = "";
        }
        else if (form == "Publication") {
            this.Publication_edit_id = -1;
            this.Publication[id - 1].name = this.temp_publication_name;
            this.edited_publication_name = "";
            this.temp_publication_name = "";
        }

    }
    editData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool_edit_id = Number(id);
            this.temp_medicalSchool_name = this.medicalSchool[id - 1].name;
            this.temp_medicalSchool_year = this.medicalSchool[id - 1].year;
            this.name = this.temp_medicalSchool_name;
            this.year_of_graduation = this.temp_medicalSchool_year;
            this.editdisplayMedicalSchool = true;
        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice_edit_id = Number(id);
            this.temp_StatesToPractice_selectedStateToPratice.state_name = this.StatesToPractice[id - 1].state_name;
            this.temp_StatesToPractice_selectedStateToPratice.state_id = this.StatesToPractice[id - 1].state_id;
            this.temp_StatesToPractice_License_no = this.StatesToPractice[id - 1].license_no;
            this.selectedStateToPratice = this.temp_StatesToPractice_selectedStateToPratice;
            this.License_no = this.temp_StatesToPractice_License_no;
            this.editdisplayStatesToPractice = true;

        }
        else if (form == "Fellowship") {
            this.fellowship_edit_id = Number(id);
            this.temp_fellowship_name = this.Fellowship[id - 1].name;
            this.temp_fellowship_year = this.Fellowship[id - 1].year;
            this.name = this.temp_fellowship_name;
            this.year_of_graduation = this.temp_fellowship_year
            this.editdisplayFellowship = true;
        }
        else if (form == "Residency") {
            this.residency_edit_id = Number(id);
            this.temp_residency_name = this.Residency[id - 1].name;
            this.temp_residency_year = this.Residency[id - 1].year;
            this.name = this.temp_residency_name;
            this.year_of_graduation = this.temp_residency_year
            this.editdisplayResidency = true;
        }
        else if (form == "Honours") {
            this.Honours_edit_id = Number(id);
            this.temp_Honours_name = this.Honours[id - 1].name;
            this.edited_honour_name = this.temp_Honours_name;
        }
        else if (form == "Privileges") {
            this.Privileges_edit_id = Number(id);
            this.temp_privileges_name = this.Privileges[id - 1].name;
            this.edited_privileges_name = this.temp_privileges_name;
        }
        else if (form == "Boards") {
            this.Boards_edit_id = Number(id);
            this.temp_boards_name = this.Board[id - 1].name;
            this.edited_boards_name = this.temp_boards_name;
        }
        else if (form == "Publication") {
            this.Publication_edit_id = Number(id);
            this.temp_publication_name = this.Publication[id - 1].name;
            this.edited_publication_name = this.temp_publication_name;
        }
    }

    saveData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool[id - 1].name = this.name;
            this.medicalSchool[id - 1].year = this.year_of_graduation.toString();
            this.medicalSchool_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayMedicalSchool = false;
            this.temp_medicalSchool_name = "";
            this.temp_medicalSchool_year = null;

        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice[id - 1].state_name = this.selectedStateToPratice.state_name;
            this.StatesToPractice[id - 1].state_id = this.selectedStateToPratice.state_id;
            this.StatesToPractice[id - 1].license_no = this.License_no;
            this.StatesToPractice_edit_id = -1;
            this.selectedStateToPratice = null;
            this.License_no = "";
            this.editdisplayStatesToPractice = false;
            this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
            this.temp_StatesToPractice_License_no = "";

        }
        else if (form == "Fellowship") {
            this.Fellowship[id - 1].name = this.name;
            this.Fellowship[id - 1].year = this.year_of_graduation.toString();
            this.fellowship_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayFellowship = false;
            this.temp_fellowship_name = "";
            this.temp_fellowship_year = null;
        }
        else if (form == "Residency") {
            this.Residency[id - 1].name = this.name;
            this.Residency[id - 1].year = this.year_of_graduation.toString();
            this.residency_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayResidency = false;
            this.temp_residency_name = "";
            this.temp_residency_year = null;
        }
        else if (form == "Honours") {
            this.Honours[id - 1].name = this.edited_honour_name;
            this.Honours_edit_id = -1;
            this.edited_honour_name = "";
            this.temp_Honours_name = "";
        }
        else if (form == "Privileges") {
            this.Privileges[id - 1].name = this.edited_privileges_name;
            this.Privileges_edit_id = -1;
            this.edited_privileges_name = "";
            this.temp_privileges_name = "";
        }
        else if (form == "Boards") {
            this.Board[id - 1].name = this.edited_boards_name;
            this.Boards_edit_id = -1;
            this.edited_boards_name = "";
            this.temp_boards_name = "";
        }
        else if (form == "Publication") {
            this.Publication[id - 1].name = this.edited_publication_name;
            this.Publication_edit_id = -1;
            this.edited_publication_name = "";
            this.temp_publication_name = "";
        }
    }

    confirmMedicalSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-medicalSchool',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteMedicalSchool(product);
            },
        });

    }

    confirmStatesToPracticeSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-StatesToPractice',
            message: 'Are you sure to delete the ' + product.state_name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteStatestoPratice(product);
            },
        });

    }
    confirmFellowshipSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-fellowship',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteFellowship(product);
            },
        });

    }

    confirmResidencySelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-residency',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteResidency(product);
            },
        });

    }

    confirmHonoursSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-honours',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteHonours(product);
            },
        });


    }

    confirmPrivilegesSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-privileges',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deletePrivileges(product);
            },
        });

    }

    confirmBoardsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-boards',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteBoard(product);
            },
        });

    }

    confirmPublicationSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-publication',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deletePublication(product);
            },
        });

    }

    fileChangeEvent(event: any): void {
        // debugger;

        this.imageChangedEvent = event;
        if (SIGNATURE_TYPES.includes(event.target.files[0].type.toString())) {
            this.signature_file_type_error = false;
            this.signature_file_name = event.target.files[0].name

        }
        else {
            this.signature_file_type_error = true;
            this.imageChangedEvent = "";
            this.croppedImage = "";
            this.canvasRotation = 0;
            this.rotation = 0;
            this.scale = 1;
            this.showCropper = false;
            this.containWithinAspectRatio = false;
            this.transform = {};
            this.signature_file_name = "";
        }
    }

    imageCropped(event: ImageCroppedEvent) {

        this.croppedImage = event.base64;

        this.signatureFile = base64ToFile(event.base64);
    }

    imageLoaded() {

        this.showCropper = true;

    }

    cropperReady(sourceImageDimensions: Dimensions) {

    }

    loadImageFailed() {

    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }

    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }

    zoomOut() {
        this.scale -= 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomIn() {
        this.scale += 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    updateRotation() {
        this.transform = {
            ...this.transform,
            rotate: this.rotation
        };
    }

    addSignature() {
        this.showCropper = false;
        this.signature_file_type_error = false;
        this.signatureDialog = true;


    }

    saveSignature() {
        this.signatureDialog = false;

    }

    async addNewSpeciality() {
        const temp: SelectItem[] = this.sec_specialities;


        let tempaddedSpeciality = this.addedSpeciality.trim().toLowerCase().split(" ");
        for (let i = 0; i < tempaddedSpeciality.length; i++) {
            tempaddedSpeciality[i] = tempaddedSpeciality[i][0].toUpperCase() + tempaddedSpeciality[i].slice(1);
        }
        let b = tempaddedSpeciality.join(" ");
        //  code for /

        let tempSpaecialitiesName: string[] = [];
        for (let i = 0; i < temp.length; i++) {
            tempSpaecialitiesName.push(temp[i].label);
        }
        tempSpaecialitiesName.push(b);
        this.selectedSecondarySpeciality.push(b.toString());


        let tempSpaecialities = Array.from(new Set(tempSpaecialitiesName)).sort()
        let temp1: SelectItem[] = [];
        for (let i = 0; i < tempSpaecialities.length; i++) {
            temp1.push({ label: tempSpaecialities[i].toString(), value: tempSpaecialities[i].toString() });
        }
        this.sec_specialities = temp1;
        this.addedSpeciality = "";

    }

    async submitData(): Promise<void> {
        if (this.currentRoleID == 1 || this.currentRoleID == 4 || this.currentRoleID == 5) {
            await this.ResetResultModels();
            this.posting = true;


            // Password 
            if (this.changePassword) {
                this.doctorreg.is_password = true;
                this.doctorreg.d_password = this.password;

            }
            else if (!this.changePassword) {
                this.doctorreg.is_password = false;
                this.doctorreg.d_password = "";

            }
            // Pin 
            if (this.changePin) {
                this.doctorreg.is_pin = true;
                // this.doctorreg.password=this.password;
            }
            else if (!this.changePin) {
                this.doctorreg.is_pin = false;
                this.doctorreg.pin = "";
            }

            if (this.doctorreg.date_of_birth_date == null) {
                this.doctorreg.date_of_birth = null;
            }
            else if (this.doctorreg.date_of_birth_date != null) {
                this.doctorreg.date_of_birth = this.daterenderService.render_data(this.doctorreg.date_of_birth_date);
            }

            if (this.selectedCountry == null) {
                this.doctorreg.country_id = null;
            }
            else if (this.selectedCountry != null) {
                this.doctorreg.country_id = Number(this.selectedCountry.id);
            }

            if (this.selected_salutation == null) {
                this.doctorreg.salutation = null;
            }
            else if (this.selected_salutation != null) {
                this.doctorreg.salutation = this.selected_salutation.value;
            }

            if (this.selectedState == null) {
                this.doctorreg.state_name = null;
            }
            else if (this.selectedState != null) {
                this.doctorreg.state_name = this.selectedState.state_name;
            }

            if (this.seletedPrimarySpeciality == null) {
                this.doctorreg.primary_speciality_id = null;
            }
            else if (this.seletedPrimarySpeciality != null) {
                this.doctorreg.primary_speciality_id = this.seletedPrimarySpeciality.id;
            }

            // this.doctorreg.country_id = Number(this.selectedCountry.id);
            // this.doctorreg.date_of_birth = this.daterenderService.render_data(this.doctorreg.date_of_birth_date);
            if (this.doctorreg.years_experience == null) {
                this.doctorreg.years_experience = null;
            }
            else if (this.doctorreg.years_experience != null) {
                this.doctorreg.years_experience = Number(this.doctorreg.years_experience);
            }
            // if(this.statesInput==true)
            // {
            //     this.doctorreg.state_name=this.selectedState;
            // }
            // else if(this.statesInput==false)
            // {
            // this.doctorreg.state_name = this.selectedState.state_name;
            // }
            // this.doctorreg.primary_speciality_id = this.seletedPrimarySpeciality.id;
            this.doctorreg.education = { medical_school: this.medicalSchool, residency: this.Residency, fellowship: this.Fellowship };

            if (!this.national_license) {
                let tempStatesToPractice: StatesToPractice[] = [];
                // for(let i=0;i<this.StatesToPractice.length;i++)
                // {
                //  this.doctorreg.states_to_practice.push(this.StatesToPractice[i].name);
                tempStatesToPractice = this.StatesToPractice;
                // }
                this.doctorreg.states_to_practice = tempStatesToPractice;
            }
            else if (this.national_license) {
                let tempStatesToPractice: StatesToPractice[] = [];
                if (this.national_license_no.length > 0)
                    tempStatesToPractice.push({ si_no: (1).toString(), state_name: "ALL", state_id: 0, license_no: this.national_license_no, state_data: JSON.stringify({ state_name: "ALL", state_id: 0 }) });
                this.doctorreg.states_to_practice = tempStatesToPractice;
            }

            let tempBoard: string[] = [];
            for (let i = 0; i < this.Board.length; i++) {
                //  this.doctorreg.board_certification.push(this.Board[i].name)
                tempBoard.push(this.Board[i].name)
            }
            this.doctorreg.board_certification = tempBoard;

            let tempHonours: string[] = [];
            for (let i = 0; i < this.Honours.length; i++) {
                //  this.doctorreg.honors_award.spush(this.Honours[i].name)
                tempHonours.push(this.Honours[i].name)
            }
            this.doctorreg.honors_awards_recognition = tempHonours;

            let tempPublication: string[] = [];
            for (let i = 0; i < this.Publication.length; i++) {
                //  this.doctorreg.publications.push(this.Publication[i].name)
                tempPublication.push(this.Publication[i].name)
            }
            this.doctorreg.publications = tempPublication

            let tempPrivileges: string[] = [];
            for (let i = 0; i < this.Privileges.length; i++) {
                //  this.doctorreg.hospital_privileges.push(this.Privileges[i].name)
                tempPrivileges.push(this.Privileges[i].name)
            }
            this.doctorreg.hospital_privileges = tempPrivileges

            if (this.primary_contact_number?.length > 0) {
                this.doctorreg.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
            }
            if (this.secondary_contact_number?.length > 0) {
                this.doctorreg.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
            }


            this.doctorreg.current_user_guid = this.current_doctor_userid;
            // this.doctorreg.current_guid='1872468e-9528-42b1-a172-014c3445154c'
            this.doctorreg.license_number = "license";



            this.doctorreg.secondary_speciality = this.selectedSecondarySpeciality;

            let tempselectedLanguageSpoken: string[] = [];
            for (let i = 0; i < this.selected_language.length; i++) {
                tempselectedLanguageSpoken.push(this.selected_language[i].id);
            }

            this.doctorreg.language_id = tempselectedLanguageSpoken;


            // try {
            if (this.is_revalidation_cme_false) {
                if (this.selectedRevalidation_cme != null) {
                    this.doctorreg.revalidation_cme = Number(this.selectedRevalidation_cme.value);
                }
                else {
                    this.doctorreg.revalidation_cme == null
                }
            }
            else if (this.is_revalidation_cme_false)
                this.doctorreg.revalidation_cme = null;
            // } catch (error) {
            // this.doctorreg.revalidation_cme = null;

            // }

            // this.doctorreg.salutation = this.selected_salutation.value;

            this.doctorreg_boolean = await this.doctorRegistrationCheckerService.DoctorProfileUpdateFormSubmitChecker(this.doctorreg, false, this.changePhoto, this.profilePhoto, this.changeResume, this.resume, this.changeSignature, this.signatureOptionSelected, this.signatureFile, this.password, this.confirmPassword)
            this.error_message_result = await this.doctorRegistrationCheckerService.getDoctorProfileUpdateFormErrors(this.doctorreg_boolean, this.national_license);
            if (!Boolean(this.error_message_result.success)) {
                this.posting = false;
            }
            else if (Boolean(this.error_message_result.success)) {
                await this.updateDoctor();
            }


        }
        else if (this.currentRoleID == 2 || this.currentRoleID == 3) {
            await this.ResetResultModels();
            this.posting = true;


            // Password 
            if (this.changePassword) {
                this.doctorreg.is_password = true;
                this.doctorreg.d_password = this.password;

            }
            else if (!this.changePassword) {
                this.doctorreg.is_password = false;
                this.doctorreg.d_password = "";


            }
            // Pin 


            this.doctorreg.country_id = Number(this.selectedCountry.id);
            this.doctorreg.date_of_birth = this.daterenderService.render_data(this.doctorreg.date_of_birth_date);
            // if(this.statesInput==true)
            // {
            //     this.doctorreg.state_name=this.selectedState;
            // }
            // else if(this.statesInput==false)
            // {
            this.doctorreg.state_name = this.selectedState.state_name;
            // }





            this.doctorreg.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
            if (this.doctorreg.secondary_contact_number.length > 0) {
                this.doctorreg.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
            }

            this.doctorreg.current_user_guid = this.current_doctor_userid;
            // this.doctorreg.current_guid='1872468e-9528-42b1-a172-014c3445154c'
            this.doctorreg.license_number = "license";



            this.doctorreg.secondary_speciality = this.selectedSecondarySpeciality;

            this.doctorreg.language_id = null;
            this.doctorreg.primary_speciality_id = null;
            this.doctorreg.secondary_speciality = null;
            this.doctorreg.years_experience = null;
            this.doctorreg.license_number = null;
            this.doctorreg.education = null;
            this.doctorreg.npi_number = null;
            this.doctorreg.revalidation_cme = null;
            this.doctorreg.states_to_practice = null;
            this.doctorreg.board_certification = null;
            this.doctorreg.honors_awards_recognition = null;
            this.doctorreg.publications = null;
            this.doctorreg.hospital_privileges = null;
            this.doctorreg.description = null;
            this.doctorreg.pin = null;
            this.doctorreg.is_pin = false;

            await this.updateAdmin();

        }
    }

    async updateDoctor() {
        let doctor_guid = this.doctor_userid;


        let a: boolean = true;
        await this.doctorsservice.updateDoctor(this.doctorreg, doctor_guid).toPromise().then(result => {

            this.response = result;
            this.updateDataResult = result.success;
            // a=a && this.updateDataResult;
            if (!this.response.success) {
                this.error = result.error;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    sticky: true,
                    detail: result.error.code + " : " + result.error.message,
                });
                this.posting = false;
            }

        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });

        if (this.updateDataResult != null && this.updateDataResult == false) {
            return;
        }


        if (this.changePhoto == true) {
            if (this.profilePhoto != null) {
                let formPhoto: FormData = new FormData();
                // formPhoto.set("current_user_guid", this.doctorreg.current_user_guid);
                formPhoto.set("file", this.profilePhoto);

                await this.doctorsservice.UploadDoctorProfilePhoto(formPhoto, doctor_guid).toPromise().then(result => {

                    this.response = result;
                    this.profile_result = result.success;
                    //  a=a && this.profile_result;
                    if (this.response.success) {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Photo Updated Successfully",
                        });
                    }
                    else if (!this.response.success) {
                        this.error = result.error;
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            sticky: true,
                            detail: result.error.code + " : " + result.error.message,
                        });
                        this.posting = false;
                    }
                }).catch((error: HttpErrorResponse) => {
                    this.serverError = error.error;
                    this.response.success = false;
                    this.posting = false;
                });
                if (this.profile_result != null && this.profile_result == false) {
                    return;
                }
            }
        }

        if (this.changeResume == true) {
            if (this.resume != null) {

                let formResume: FormData = new FormData();
                // formResume.set("current_user_guid", this.doctorreg.current_user_guid);
                formResume.set("file", this.resume);

                await this.doctorsservice.UploadDoctorResume(formResume, doctor_guid).toPromise().then(result => {

                    this.resume_result = result.success;
                    this.response = result;
                    //  a=a && this.resume_result;
                    if (this.response.success) {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Resume Updated Successfully",
                        });
                    }
                    else if (!this.response.success) {
                        this.error = result.error;
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            sticky: true,
                            detail: result.error.code + " : " + result.error.message,
                        });
                        this.posting = false;
                    }
                }).catch((error: HttpErrorResponse) => {
                    this.serverError = error.error;
                    this.response.success = false;
                    this.posting = false;
                });
                if (this.resume_result != null && this.resume_result == false) {
                    return;
                }
            }
        }

        if (this.changeSignature == true) {
            if (this.signatureOptionSelected != null) {
                if (this.signatureOptionSelected == 'draw') {
                    await this.print(doctor_guid);
                    //    a=a && this.sig_result;
                }
                else if (this.signatureOptionSelected == 'upload') {
                    await this.blobToImageUpload(this.signatureFile, doctor_guid);
                    // a=a && this.sig_result;
                }

            }
            if (this.sig_result != null && this.sig_result == false) {
                return;
            }
        }

        // this.posting = false;
        if ((this.updateDataResult || this.sig_result || this.profile_result || this.resume_result)) {
            // if ((this.updateDataResult || this.sig_result || this.profile_result || this.resume_result) && !(this.posting)) {
            // if (a && !(this.posting)) {
            this.showForm = false;
            this.display = true;
            this.showDialog();
        }
    }

    async updateAdmin() {
        let doctor_guid = this.doctor_userid;
        await this.doctorsservice.updateDoctor(this.doctorreg, doctor_guid).toPromise().then(result => {

            this.response = result;
            this.updateDataResult = result.success;
            if (!this.response.success) {
                this.error = result.error;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    sticky: true,
                    detail: result.error.code + " : " + result.error.message,
                });
                this.posting = false;
            }

        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        if (this.updateDataResult != null && this.updateDataResult == false) {
            return;
        }

        if (this.changePhoto == true) {
            if (this.profilePhoto != null) {
                let formPhoto: FormData = new FormData();
                // formPhoto.set("current_user_guid", this.doctorreg.current_user_guid);
                formPhoto.set("file", this.profilePhoto);

                await this.doctorsservice.UploadDoctorProfilePhoto(formPhoto, doctor_guid).toPromise().then(result => {

                    this.profile_result = result.success;
                    this.response = result;
                    if (this.response.success) {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Photo Updated Successfully",
                        });
                    }
                    else if (!this.response.success) {
                        this.error = result.error;
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            sticky: true,
                            detail: result.error.code + " : " + result.error.message,
                        });
                        this.posting = false;
                    }
                }).catch((error: HttpErrorResponse) => {
                    this.serverError = error.error;
                    this.response.success = false;
                    this.posting = false;
                });

                if (this.profile_result != null && this.profile_result == false) {
                    return;
                }
            }
        }

        this.posting = false;
        if ((this.updateDataResult || this.profile_result) && !(this.posting)) {
            this.showForm = false;
            this.display = true;
            this.showDialog();
        }
    }


    async print(doctor_guid: string) {

        await this.canvas.nativeElement.toBlob(async (res: Blob) => {

            const file = new File([res], "signature.png", { type: "image/png", lastModified: new Date().valueOf() })
            await this.UploadSignature(file, doctor_guid);

        });

    }
    async blobToImageUpload(blob, doctor_guid) {
        const file = new File([blob], "signature.png", { type: "image/png", lastModified: new Date().valueOf() })
        await this.UploadSignature(file, doctor_guid);
    }

    async UploadSignature(file: File, doctor_guid: string) {
        let form: FormData = new FormData()
        form.set('file', file);
        // form.set('current_user_guid', this.doctorreg.current_user_guid);
        await this.doctorsservice.UploadSignature(form, doctor_guid).toPromise().then(result => {

            this.sig_result = result.success;
            this.response = result;
            if (this.response.success) {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "eSignature Updated Successfully",
                });
            }
            else if (!this.response.success) {
                this.error = result.error;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    sticky: true,
                    detail: result.error.code + " : " + result.error.message,
                });
                this.posting = false;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });

    }

    // temp_submit(){
    //     this.showForm=false;
    //     this.display = true;
    //     this.showDialog();
    // }

    gotodashboard() {
        this.RouterNavigation("/" + this.slug + "/doctor/dashboard");
    }


    changeType() {
        this.isPassword = !this.isPassword;

    }



    showTips() {
        this.tipsshowed = !this.tipsshowed;
    }

    changeSignatureOption() {
        if (this.signatureOptionSelected == 'draw') {
            const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
            this.cx = canvasEl.getContext("2d");
            canvasEl.width = this.width;
            canvasEl.height = this.height;
            this.cx.lineWidth = 3;
            this.cx.lineCap = "round";
            this.cx.strokeStyle = "#000";
            this.captureEvents(canvasEl);
            canvasEl.toBlob((res) => {

            })

        }
        this.imageChangedEvent = "";
        this.croppedImage = "";
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.signature_file_name = "";
    }

    clearSignatureDraw() {
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext("2d");
        canvasEl.width = this.width;
        canvasEl.height = this.height;
        this.cx.lineWidth = 3;
        this.cx.lineCap = "round";
        this.cx.strokeStyle = "#000";
        this.captureEvents(canvasEl);
        canvasEl.toBlob((res) => {

        });

    }

    download(url: string, name: string) {
        const Url = url;
        const Name = name;
        saveAs(Url, Name);

    }

    async submitDoctorRegistration() {
        let waitSec = Number((Math.floor(Math.random() * 1000) + 1) % 3);
        this.posting = true;
        setTimeout(async () => {
            this.submitData();
        }, 5000 + waitSec);
    }

    async recaptchaReset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000)
    }

    resolved(captchaResponse: any) {
        this.doctorreg.recaptcha = captchaResponse;

    }

}


